let lastUniqueId = 0;

/**
 * Creates either a NodeList or an Array from one of the following:
 *
 * * A selector string
 * * A node
 * * A node list
 */
function elementsFrom(src) {
  if (typeof src === 'string') {
    return document.querySelectorAll(src);
  }
  else if (src instanceof Node) {
    return [ src ];
  }
  else if ((src instanceof NodeList) || (src instanceof Array)) {
    return src;
  }
  else {
    error.log("Could not convert to elements: ", src);
    return null;
  }
}

function forceReflow(el) {
  void(el.offsetHeight);
}

function uniqueId() {
  return 'pt-uniq-' + (uniqueId++);
}

function nodeFromIdOrNode(src) {
  if (typeof src === 'string') {
    return document.querySelector(`#${ src }`);
  }
  else if (src instanceof Node) {
    return src
  }

  error.log("Could not convert to node: ", src);
}
  
function undefinedToNull(val) {
  return (val === undefined) ? null : val;
}

function undefinedOrEmptyToNull(val) {
  return ((val === undefined) || (val === '')) ? null : val;
}

/**
 * Products an element from a "template element".  This is a simple javascript clone with a few conventions.
 * 
 * * Identified by an ID (the templateId parameter), which is removed in the clone
 * * Can have its style set to display:none, which is removed in the clone
 * * If the template has a class named "template", this class is removed (can be used as an alternative to display:none)
 */
function elFromTemplate(templateId) {
  const template = (templateId instanceof Node) ? templateId : document.getElementById(templateId);

  // No element?  Graceful-ish failure by returning an empty div.  Usually I favour hard-fails but
  // a javascript error can prevent rendering the rest of the page so this can save devs from themselves
  // if a template is misnamed or misplaced.
  if (!template) {
    console.error(`Could not find template with ID '${ templateId }'`);
    const dummyEl = document.createElement('div');
    return dummyEl;
  }
  
  
  const el = template.cloneNode(true);
  el.removeAttribute('id');
  el.classList.remove('template');
  el.style.removeProperty('display');
  
  return el;
}

function throttle(fn, waitMs = 200) {
  let inThrottle, lastFn, lastTime;

  return function() {
    const context = this;
    const args = arguments;
    
    if (inThrottle) {
      const sinceLast = (Date.now() - lastTime);
      const triggerWait = Math.max(waitMs - sinceLast, 0);

      clearTimeout(lastFn);
      lastFn = setTimeout(function() {
        const sinceLastInner = (Date.now() - lastTime);
        
        if (sinceLastInner >= waitMs) {
          fn.apply(context, args);
          lastTime = Date.now();
        }
      }, triggerWait);
    }
    else {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    }
  };
}

/**
 * Prepares an element for a transition from/to "display:none", allowing the
 * transition to be fully displayed, then removing it once it's complete.
 *
 * Sets style='display: <value>' on the element itself.  This override remains until
 * the element receives a transitionend, transitioncancel, animationend, or animationcancel event.
 *
 * @param display string The transitional display property value.  Generally this will be the display value when the the element is fully visible
 */
function prepDisplayNoneTransition(el, display = 'block') {
  if (el.nst_displayNoneTransitionHandler) { return; }

  const transitionHandler = () => {
    el.removeEventListener('transitionend', transitionHandler);
    el.removeEventListener('transitioncancel', transitionHandler);
    el.removeEventListener('animationend', transitionHandler);
    el.removeEventListener('animationcancel', transitionHandler);
    el.nst_displayNoneTransitionHandler = null;
    el.style.display = null;
  };
  
  el.addEventListener('transitionend', transitionHandler);
  el.addEventListener('transitioncancel', transitionHandler);
  el.addEventListener('animationend', transitionHandler);
  el.addEventListener('animationcancel', transitionHandler);
  el.nst_displayNoneTransitionHandler = transitionHandler;
  el.style.display = display;
  forceReflow(el);
}

const Util = {
  elementsFrom,
  elFromTemplate,
  forceReflow,
  nodeFromIdOrNode,
  prepDisplayNoneTransition,
  undefinedToNull,
  undefinedOrEmptyToNull,
  uniqueId
};

window.Plaintext = window.Plaintext || {};
window.Plaintext.Util = Util;

export default Util;

/**
 * Copyright 2023 Plaintext Inc.
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
